var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","margin-bottom":"45px"}},[_c('Carrosel',{attrs:{"images":_vm.home.banners}}),_c('Cards',{attrs:{"cards":_vm.home.cards}}),_c('News',{attrs:{"news":_vm.home.news}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }